/**
 * Script upload form: remove Globo gfb__no-label so placeholders show on repeater rows.
 */
(function () {
  var ROOT_SELECTORS = [
    '.my-custom-scirpt-upload',
    '#script-upload-card .globo-formbuilder',
    '.script-upload-card__form .globo-formbuilder'
  ];
  var NO_LABEL_CLASS = 'gfb__no-label';

  function getRoots() {
    var roots = [];
    ROOT_SELECTORS.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (el) {
        if (roots.indexOf(el) === -1) {
          roots.push(el);
        }
      });
    });
    return roots;
  }

  function fixNoLabelFields(root) {
    if (!root) return;

    root.querySelectorAll('.' + NO_LABEL_CLASS).forEach(function (el) {
      el.classList.remove(NO_LABEL_CLASS);
    });

    root.querySelectorAll('input, textarea').forEach(function (input) {
      if (!input.getAttribute('placeholder')) return;
      input.style.setProperty('-webkit-text-fill-color', 'currentColor', 'important');
    });
  }

  function run() {
    var roots = getRoots();
    if (!roots.length) return false;

    roots.forEach(function (root) {
      fixNoLabelFields(root);
      watchForm(root);
    });
    return true;
  }

  function watchForm(root) {
    if (!root || root._gfbNoLabelWatcher) return;

    root._gfbNoLabelWatcher = true;

    var observer = new MutationObserver(function () {
      fixNoLabelFields(root);
    });

    observer.observe(root, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });
  }

  function init() {
    if (run()) return;

    var tries = 0;
    var interval = setInterval(function () {
      tries += 1;
      if (run() || tries >= 40) {
        clearInterval(interval);
      }
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('globoFormRender', init);
  document.addEventListener('globoFormBuilderRender', init);
})();
